<script setup>
import { computed } from 'vue'
import { useStore } from 'vuex'

const store = useStore()

const loading = computed(() => store.state.project.loading)
const toggleProjectDialog = (payload) => store.dispatch('project/toggleProjectDialog', payload)
</script>

<template>
  <v-card variant="flat" elevation="0" v-if="!loading">
    <v-card-title>
      My projects
      <v-btn
        class="ml-1"
        prepend-icon="mdi-plus"
        color="primary"
        elevation="0"
        @click="toggleProjectDialog(null)"
      >
        Add
      </v-btn>
    </v-card-title>
    <v-card-subtitle>
      To start using <strong>PACE</strong>, please select an existing project below or create a new
      project via the
      <v-btn
        class="mx-1 cursor-default text-none"
        prepend-icon="mdi-plus"
        size="small"
        color="primary"
        flat
        :ripple="false"
        readonly
      >
        Add
      </v-btn>
      button.
    </v-card-subtitle>
  </v-card>
</template>
